import React, {Fragment} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Spin
} from "antd";

import {
    DownOutlined,
    DownloadOutlined,
    DeleteOutlined,
    PlusOutlined,
    EuroCircleOutlined,
    LinkOutlined,
    MinusOutlined
} from '@ant-design/icons';

import ApiService from "../services/ApiService"

import IntlMessage from "../components/util-components/IntlMessage";
import {API_BASE_URL} from "../configs/AppConfig";
import ModalPromesse from "./ModalPromesse";
import ModalPayement from "./ModalPayement";
import ResponsiveTable from "../components/ResponsiveTable";
import Index from "../views/app-views/contact/Fiche";
import RestrictedAlert from "../components/permissions/RestrictedAlert";
import {isMobile} from "react-device-detect";
import PermissionAlert from "../components/permissions/PermissionAlert";


const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default class ModalContact extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    state = {
        visible: false,
        loading: false,
        data: null,
        id: null
    };

    async show(id) {
        console.log("CONTACT ", id)

        this.setState({visible: true, loading: false, id: id})

    }

    close() {
        this.setState({
            visible: false,
            loading: false,
            data: null,
        })
    }

    async getData() // INTERFACE
    {
    }

    render() {

        return (
            <Fragment>
                <Modal bodyStyle={{padding: 0}} style={{marginTop: 0, top: isMobile ? 20 : undefined}} width={"100%"}
                       title={"Fiche Contact"} open={this.state.visible} destroyOnClose closable footer={null}
                       onCancel={() => this.close()}>
                    <PermissionAlert permissions={["contact.read"]}>
                        {this.state.id && <Index parent={this} id={this.state.id}/>}
                    </PermissionAlert>
                </Modal>
            </Fragment>

        )
    }
}

